let GMTtoLocalTime = (value) => {
  let d = new Date();
  let gmtTime = new Date(value);
  let isValid = isValidDate(new Date(gmtTime));
  if (!isValid) {
    return '0000/00/00 00:00:00';
  }
  let localTimezone = -(d.getTimezoneOffset() / 60);
  gmtTime.setHours(gmtTime.getHours() + localTimezone);
  let strTimeformat = TimetoString(gmtTime);
  return strTimeformat;
};
let TimetoString = (dateTime) => {
  // 需要try catch 檢查傳入的date_time，是否為有效日期。若是無效，return  '0000/00/00 00:00:00'

  let isValid = isValidDate(new Date(dateTime));
  if (!isValid) {
    return '0000/00/00 00:00:00';
  }
  let year = dateTime.getFullYear() < 10 ? '0' + dateTime.getFullYear() : dateTime.getFullYear();
  let month = dateTime.getMonth() + 1 < 10 ? '0' + (dateTime.getMonth() + 1) : dateTime.getMonth() + 1;
  let day = dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
  let hour = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours();
  let minutes = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes();
  let seconds = dateTime.getSeconds() < 10 ? '0' + dateTime.getSeconds() : dateTime.getSeconds();
  let strTimeformat = year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  return strTimeformat;
};
function isValidDate (d) {
  return d instanceof Date && !isNaN(d.getTime());
}

function FullTimeToDate (time) {
  let arrTime = time.split(' ');
  return arrTime[0];
}
export { isValidDate, GMTtoLocalTime, FullTimeToDate, TimetoString };
